import moment from 'moment'

export default {
  data() {
    return {
      loader: false,
      totalCount: 0,
      currentPage: 1,
      perPage: 25,
      users: [],
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      searchUser: [],
      is_active: 'active',
      activeBtn: null,
      payload: {},
      reports: [],
      abnormalityType: [],
    }
  },
  computed: {
    filterUserOptions() {
      return this.sortedEmpIdUser(this.users)
    },

    abnormalityTypeOptions() {
      return [
        { value: 'in_in', label: 'Double In' },
        { value: 'out_out', label: 'Double Out' },
        { value: 'out_not_in', label: 'Out without In' },
        { value: 'in_not_out', label: 'In without Out' },
      ]
    },

    tableFields() {
      return [
        { key: 'employee_id', label: 'Emp ID', sortable: true, thStyle: { width: '100px' } },
        { key: 'employee_name', label: 'Employee', sortable: true, thStyle: { width: '200px' } },
        { key: 'reporting_to', label: 'Reporting To', sortable: true, thStyle: { width: '200px' } },
        { key: 'manage_by', label: 'Manage By', sortable: true, thStyle: { width: '200px' } },
        { key: 'date', label: 'Date', sortable: true, thStyle: { width: '150px' } },
        { key: 'type', label: 'Type', sortable: true, thStyle: { width: '150px' } },
        { key: 'punch_time', label: 'Punch Time', sortable: true, thStyle: { width: '200px' } },
      ]
    },
  },
  watch: {
    currentPage(val) {
      if (val) this.getAclAbnormalitiesLogs()
    },
    perPage() {
      if (this.currentPage === 1) {
        this.getAclAbnormalitiesLogs()
      } else {
        this.currentPage = 1
      }
    },
    is_active() {
      this.userList()
    },
  },

  mounted() {
    const queryParams = this.$route.query

    if (queryParams && Object.keys(queryParams).length > 0) {
      if (queryParams.is_active) this.is_active = queryParams.is_active
      if (queryParams.searchUser) {
        this.searchUser = queryParams.searchUser.split(',').filter(Boolean)
      }
      if (queryParams.abnormalityType) {
        this.abnormalityType = queryParams.abnormalityType.split(',').filter(Boolean)
      }
      
      this.startDate = queryParams.startDate || moment().subtract(7, 'days').format('YYYY-MM-DD')
      this.endDate = queryParams.endDate || moment().format('YYYY-MM-DD')
      
      if (queryParams.active) this.activeBtn = queryParams.active
      if (queryParams.perPage) this.perPage = Number(queryParams.perPage)
      if (queryParams.currentPage) this.currentPage = Number(queryParams.currentPage)
    }

    this.getAclAbnormalitiesLogs()
    this.userList()
  },

  methods: {
    async userList() {
      const input = {
        sort_field: 'name',
        sort_order: 'asc',
        include_system_users: 1,
        is_active: this.is_active && this.is_active !== 'all_data'
          ? this.is_active === 'active'
          : '',
      }
      const response = await this.getHTTPPostResponse(
        'admin/master/user/active-inactive-userlist',
        input,
        false,
      )
      if (response && response.data) {
        const { data } = response
        this.users = data.users
      }
    },
    updateDate(obj) {
      this.startDate = obj?.startDate || null
      this.endDate = obj?.endDate || null
      this.activeBtn = obj?.active || null
      this.currentPage = 1
      this.getAclAbnormalitiesLogs()
    },
    
    applyFilter() {
      this.currentPage = 1
      this.getAclAbnormalitiesLogs()
    },

    clearFilter() {
      this.resetFilterState()
      this.reports = []
      this.getAclAbnormalitiesLogs()
    },

    resetFilterState() {
      this.startDate = moment().subtract(7, 'days').format('YYYY-MM-DD')
      this.endDate = moment().format('YYYY-MM-DD')
      this.searchUser = []
      this.is_active = 'active'
      this.abnormalityType = []
      this.activeBtn = null
      this.currentPage = 1
      this.perPage = 25
    },

    updateQueryParams() {
      const query = this.getQueryParams()
      // Push the query parameters to the route
      this.routeQueryUpdate(query)
    },

    getQueryParams() {
      const queryParams = {
        startDate: this.startDate,
        endDate: this.endDate,
        searchUser: this.searchUser.join(",") || null,
        abnormalityType: this.abnormalityType.join(",") || null,
        is_active: this.is_active,
        active: this.activeBtn,
        perPage: this.perPage,
        currentPage: this.currentPage,
      }

      // Filter out null or empty values from the query object
      return Object.keys(queryParams).reduce((acc, key) => {
        if (queryParams[key] || queryParams[key] === 0) acc[key] = queryParams[key]
        return acc
      }, {})
    },

    async getAclAbnormalitiesLogs() {
      this.loader = true
      this.updateQueryParams()
      const input = {
        page: this.currentPage,
        per_page: this.perPage,
        start_date: this.startDate,
        end_date: this.endDate,
        user_ids: this.searchUser,
        types: this.abnormalityType,
      }

      if (this.is_active && this.is_active !== 'all_data') {
        input.is_active = this.is_active === 'active' ? 1 : 0
      }

      this.payload = input

      try {
        const response = await this.getHTTPPostResponse('admin/master/reports/acl-abnormalities-report', input, false)
        
        if (response && response.status === 200) {
          const { data } = response
          this.totalCount = data.count || 0
          this.reports = data.acl_abnormalities_report || []
        } else {
          this.reports = []
          this.totalCount = 0
        }
      } catch (error) {
        console.error('Error fetching ACL abnormalities logs:', error)
        this.reports = []
        this.totalCount = 0
      } finally {
        this.loader = false
      }
    },
    
    back() {
      this.$router.back()
    },

    sortedEmpIdUser(userList) {
      const users = [...userList] // Create a shallow copy to avoid modifying the original array
      users.sort((a, b) => {
        const nameA = `${a.name} ${a.last_name}`.toUpperCase()
        const nameB = `${b.name} ${b.last_name}`.toUpperCase()
        return nameA.localeCompare(nameB)
      })

      return users.map(element => ({
        value: element.id,
        label: `${element.full_name ? element.full_name : element.name}`,
        emp_id: element.emp_id, // Include emp_id in the dropdown options
      }))
    },

    getAbnormalityTypeLabel(type) {
      const types = {
        'in_in': 'Double In',
        'out_out': 'Double Out',
        'out_not_in': 'Out without In',
        'in_not_out': 'In without Out'
      }
      return types[type] || 'Unknown'
    },

    getAbnormalityTypeClass(type) {
      const classes = {
        'in_in': 'badge-in-in',
        'out_out': 'badge-out-out',
        'out_not_in': 'badge-out-not-in',
        'in_not_out': 'badge-in-not-out'
      }
      return classes[type] || 'badge-secondary'
    },
  },
}
